var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('BannerSmall'),_c('Feature'),(_vm.products && _vm.products.length)?_c('ProductList',{attrs:{"products":_vm.products}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }